import Header from "./Header"
import Footer from "./Footer"

const Container = (props) => {
  return (
    <div className="App">
      <Header />
      <div className={`content ${props.section ?? ""}`}>{props.children}</div>
      <Footer />
    </div>
  )
}

export default Container
